import React from 'react'

import { Cluster } from 'component-library-next'

import { useIntl } from '@app/intl/Intl'
import { ChoiceField } from '@app/lib/fields/ChoiceField/ChoiceField'
import { Radio } from '@app/lib/inputs/Radio/Radio'

export const InvoiceTypeChoiceField = () => {
  const { formatMessage } = useIntl()

  return (
    <ChoiceField
      name='invoiceType'
      defaultValue='CourtCaseInvoice'
      label={formatMessage({ id: 'CourtCases.Invoicing.Field.BillingType' })}
      render={({ register }) => (
        <Cluster role='radiogroup'>
          <Radio
            {...register({
              value: 'CourtCaseInvoice'
            })}
          >
            {formatMessage({
              id: 'CourtCases.Invoicing.Option.BillingType.CourtCaseInvoice'
            })}
          </Radio>
          <Radio
            {...register({
              value: 'ReminderNotice'
            })}
          >
            {formatMessage({
              id: 'CourtCases.Invoicing.Option.BillingType.ReminderNotice'
            })}
          </Radio>
        </Cluster>
      )}
    />
  )
}
